import request from "../utils/request";

export function getNhomTo(params) {
  return request({
    url: "nhomto",
    method: "get",
    params,
  });
}
export function getNhomToTrucThuoc(params) {
  return request({
    url: "nhomtotructhuoc",
    method: "get",
    params,
  });
}
export function addNhomTo(data) {
  return request({
    url: "nhomto",
    method: "post",
    data,
  });
}
export function editNhomTo(data) {
  return request({
    url: "nhomto",
    method: "put",
    data,
  });
}

export const LOAINHOM = [
  { name: "Bộ phận thu gom", value: "thu_gom" },
  { name: "Bộ phận phân loại", value: "phan_loai" },
  { name: "Bộ phận khác", value: "khac" },
];
